import React, { useEffect, useRef, useState } from 'react'
import DaisyTable from './DaisyTable';
import useFetchData from '../../../hooks/useFetchData';
import { searchUtils } from '../../../utils/search.utils';
import Search from './Search/Search';
import { useTable } from '../../../context/TableContext';
import Pagination from './Pagination/Pagination';
import { createColumnsWithCheckbox, getColumsVisibility, getCorrectPageCount } from '../../../utils/table.utils';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from '../Loading/LoadingSpinner';

const TableLayout = ({ headers, withCheckbox, width, children }) => {

  const defaultColumnsVisibility = withCheckbox ? getColumsVisibility([createColumnsWithCheckbox(), ...headers]) : getColumsVisibility(headers)
  const { API_URL, CLIENT_CONTENT_URL } = useTable()
  const [tableContext, setTableContext] = useState(null)
  const [pages, setPages] = useState([1]);
  const [fetchAll, setFetchAll] = useState(Array.isArray(pages) ? false : true)
  const [sorting, setSorting] = React.useState([]);
  const [tableData, setTableData] = useState(null);
  const { data, error, isLoading } = useFetchData(API_URL, true);
  const [pagination, setPagination] = React.useState({ pageIndex: 0, pageSize: 25 });
  const [totalItemsFetched, setTotalItemsFetched] = useState(data?.values?.length || 0)
  const [pageCount, setPageCount] = React.useState(1)
  const [globalFilter, setGlobalFilter] = React.useState({ keys: [], value: '' })
  const [selection, setSelection] = useState([])
  const [searchType, setSearchType] = React.useState(searchUtils.SEARCH_TYPES.exact)
  const [columnsVisibility, setColumnsVisibility] = useState(defaultColumnsVisibility)
  const scrollRef = useRef(null)
  const navigate = useNavigate()


  const paginationServer = {
    ...data?.pagination,
    fetched: totalItemsFetched,
  }

  const handleNextPage = (newPage) => {
    if (newPage !== null)
      setPages((prev) => [newPage, ...prev])
    else
      setPages((prev) => [(pages[0] + 1), ...prev])
  }


  const handleSorting = (updater) => {
    if (typeof updater !== "function") return;
    const state = updater(sorting);
    setSorting([...state]);
  }

  const handleFetchAll = () => {
    setFetchAll(true)
  }
  const handleDataChange = () => {
    setTableData((prev) => {
      return {
        pagination: data.pagination,
        values: !tableData || fetchAll ? data?.values : [...prev?.values, ...data?.values]
      }
    })
    const correctPageCount = getCorrectPageCount(data.pagination.total, pagination.pageSize)
    const pageIndex = !tableData ? 0 : pagination.pageIndex
    const totalItems = !tableData || fetchAll ? data?.values?.length : totalItemsFetched + data?.values?.length
    setPagination({ pageIndex, pageSize: data.pagination.pageCount > 1 ? pagination.pageSize : 25 })
    setPageCount(correctPageCount > 0 ? correctPageCount : 1)
    setTotalItemsFetched(totalItems)
  }

  const handleGoToContentOnRowClick = (row) => (e) => {
    if (!CLIENT_CONTENT_URL) return;
    navigate(`${CLIENT_CONTENT_URL}/${row.original.id}`)

  }



  useEffect(() => {
    setTableData(null)
  }, [API_URL])

  useEffect(() => {
    if (!isLoading && data !== null) {
      handleDataChange()
      // Check if path is "/clients" if it's sort the table by modifiedDate
      // if (window.location.pathname === '/clients') {
      //   setSorting([{ id: 'modifiedDate', desc: true }])
      // }
    }
  }, [data, isLoading])

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [scrollRef, pagination?.pageIndex])

  if (isLoading) {
    return <LoadingSpinner style="medium" />
  }

  return (
    <>

      {tableContext && React.Children.map(children, (child) => {
        return React.cloneElement(child, { setTableData, selection, setSelection, table: tableContext });
      })}


      <div ref={scrollRef} className='flex flex-row w-full justify-between flex-wrap  '>
        <Search
          columns={headers}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          setSearchType={setSearchType}
          searchType={searchType}
          columnsVisibility={columnsVisibility}
          setColumnsVisibility={setColumnsVisibility}
        />


        {
          data?.pagination?.total > 0 && tableContext &&
          <Pagination
            server={paginationServer}
            client={pagination}
            table={tableContext}
            handleFetchAll={handleFetchAll}
          />
        }
      </div>

      <DaisyTable
        data={tableData || null}
        setData={setTableData}
        columnsDefs={headers}
        fetchPage={handleNextPage}
        fetchAll={handleFetchAll}
        serverPages={pages}
        sorting={sorting}
        setSorting={handleSorting}
        pagination={pagination}
        setPagination={setPagination}
        pageCount={pageCount}
        setPageCount={setPageCount}
        globalFilter={globalFilter}
        selection={selection}
        setSelection={setSelection}
        setTableContext={setTableContext}
        columnsVisibility={columnsVisibility}
        setColumnsVisibility={setColumnsVisibility}
        searchType={searchType}
        isLoading={isLoading}
        withCheckbox={withCheckbox}
        width={width}
        goToContentOnRowClick={CLIENT_CONTENT_URL ? handleGoToContentOnRowClick : null}
      />
      <div className='flex flex-row w-full justify-end flex-wrap mb-4  '>
        {
          data?.pagination?.total > 0 && tableContext &&
          <Pagination
            server={paginationServer}
            client={pagination}
            table={tableContext}
            handleFetchAll={handleFetchAll}
          />
        }
      </div>
    </>
  );
};

export default TableLayout
